import { addToBasket, getBuyingUrlAndMethod } from '../utils';
export async function addToBasketHandler({
  detail: {
    itemCode,
    quantity,
    originalItemCode,
    replacementType,
    method: addToBasketMethod,
    placement
  }
}) {
  const {
    url,
    method
  } = getBuyingUrlAndMethod(addToBasketMethod);
  return addToBasket(url, {
    itemCode,
    quantity,
    originalItemCode,
    replacementType,
    placement
  }, method);
}
//# sourceMappingURL=addToBasketHandler.js.map